import React, { useId, useState } from 'react';
import type { FormImportReport } from '../../lib/form-import-report';

/** Persistent authoring notes leave the usable draft and its save controls available. */
export function FormImportNotes({ report }: { report: FormImportReport }) {
  const [expanded, setExpanded] = useState(false);
  const detailsId = useId();
  if (report.issues.length === 0) return null;
  const actions = { skipped: 'Skipped', changed: 'Changed', omitted: 'Not imported' };
  return (
    <section aria-label="Import notes" className="rounded-xl border border-border bg-surface/40 px-4 py-3 text-sm">
      <p role="status" className="text-muted-foreground">
        {report.importedCount} imported{report.skippedCount > 0 ? ` · ${report.skippedCount} skipped` : ''}
      </p>
      <button type="button" aria-expanded={expanded} aria-controls={detailsId} onClick={() => setExpanded(value => !value)}
        className="mt-2 inline-flex cursor-pointer items-center gap-1.5 rounded text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-volt">
        <svg aria-hidden="true" viewBox="0 0 16 16" fill="none" className={`h-3.5 w-3.5 ${expanded ? 'rotate-90' : ''}`}>
          <path d="m6 3 5 5-5 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        Import notes
      </button>
        <ul id={detailsId} hidden={!expanded} className="mt-3 space-y-3">
          {report.issues.map((issue, index) => (
            <li key={`${issue.code}-${issue.sourceIndex ?? 'source'}-${index}`} className="break-words">
              <p className="font-medium text-foreground">
                {actions[issue.action]}{issue.sourceIndex ? ` · Item ${issue.sourceIndex}` : ''}{(issue.count ?? 1) > 1 ? ` · ${issue.count} items` : ''}
              </p>
              {issue.label && <p className="whitespace-pre-wrap text-foreground">{issue.label}</p>}
              <p className="text-muted-foreground">{issue.message}</p>
            </li>
          ))}
        </ul>
    </section>
  );
}
